module.exports = __webpack_public_path__ + "img/k-white-woman-front.b5084eb8.jpg";